import { useEffect, useState } from 'react';
import type { CrudFilters } from '@refinedev/core';
import { filterValue } from './list-filters';

/**
 * Debounced free-text search wired to refine's list filters as the `q`
 * pseudo-field (matched against every string field by the data provider).
 * For pages that only need search; pages with extra filter chips (users,
 * permissions, documents) own their state↔filters pair instead.
 */
export function searchCrudFilters(search: string): CrudFilters {
  const q = search.trim();
  return q ? [{ field: 'q', operator: 'contains', value: q }] : [];
}

export function searchFilterState(filters: CrudFilters | undefined): string {
  return filterValue(filters, 'q');
}

export function useSearchFilter(
  setFilters: (filters: CrudFilters, behavior?: 'merge' | 'replace') => void,
  filters: CrudFilters,
): [string, (value: string) => void] {
  // Seeded from what refine parsed out of the URL, so the effect below
  // re-asserts a restored search instead of erasing it on mount.
  const [search, setSearch] = useState(() => searchFilterState(filters));

  useEffect(() => {
    const handle = setTimeout(() => {
      setFilters(searchCrudFilters(search), 'replace');
    }, 250);
    return () => clearTimeout(handle);
  }, [search, setFilters]);

  return [search, setSearch];
}
